class InMemoryFilterState {
  /**
   * @readonly
   * Do not modify this state directly. Use the save method to update the state.
   * You may however retrieve state data by directly referencing this
   */
  static state = {};

  static save(key, value) {
    InMemoryFilterState.state[key] = value;
  }
}

module.exports = {
  InMemoryFilterState,
};
